<template>
  <div id="Footer">
    <div class="footer">
      <h2>Let's Connect</h2>
      <br />
      <p>Interested in working together? I'd love to hear from you.</p>
      <br />
      <p>
        <router-link to="/"><span>Home</span></router-link>
        <router-link to="/#portfolio"><span>Portfolio</span></router-link>
        <a href="/resume.pdf" target="_blank"><span>Resume</span></a>
      </p>
    </div>
    <div class="footer-bg">
      <a href="#"><img src="/images/arrow_up.svg" /></a>
      <p>&#169; {{ new Date().getFullYear() }} Diana Gamarra, All Rights Reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data: function () {
    return {};
  },
  methods: {
  },
  mounted: function () {
  },
};
</script>

<style lang="scss" scoped>
#Footer {
  font-family: "Poppins", sans-serif;

  p {
    font-size: 1rem;
  }

  .footer {
    padding: 100px 0;
    text-align: center;

    h2 {
      font-weight: 800;
      color: #212529;
      text-transform: capitalize;
    }

    span {
      font-weight: 800;
      font-size: 18pt;
      margin: 0 25px;

      @media (max-width: 576px) {
        margin: 0 17px;
        font-size: 16pt;
      }
    }

    a,
    a:hover {
      color: black;
    }
  }

  .footer-bg {
    background-color: #EFF6F7;
    text-align: center;
    padding-top: 120px;
    padding-bottom: 20px;

    position: relative;

    img {
      position: absolute;
      bottom: 60px;
      right: 50px;
      width: 64px;

      @media (max-width: 576px) {
        display: none;
      }
    }
  }
}
</style>